export default __webpack_public_path__ + "assets/ttf/11eabca2251325cfc5589c9c6fb57b46.ttf";